/**
 * 组件的emit事件声明
 */
export const emits = [
  /** v-model 绑定值更新时触发 */
  'update:modelValue',
  /** 输入内容变化时触发 */
  'input',
  /** 文本域值变化且失焦时触发 */
  'change',
  /** 文本域获取焦点时触发 */
  'focus',
  /** 文本域失去焦点时触发 */
  'blur',
  /** 按下键盘按键时触发 */
  'keydown',
  /** 释放键盘按键时触发 */
  'keyup',
];
